





















































































































































































































































































































/**
 * https://www.digitalocean.com/community/tutorials/vuejs-vue-modal-component
 */

import { LineItem } from "@/models/order/order";
import { FinishDisplayName, FinishHandle } from "@/models/products/finish";
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import Swatch from "../products/Swatch.vue";
import {
  getFinishName,
  getFinialFinishDisplayName,
  priceLevelMultiplier
} from "@/utility/helpers";
import {
  Fringe,
  Valance,
  getFringeDisplayName,
  getValanceDisplayName,
  FinialFinishType
} from "@/models/configurator/configurator_options";
import { namespace } from "vuex-class";
import { StoreModule } from "@/store/types";
import { GlobalGetters } from "@/store/modules/global/types";

@Component
export default class CartModal extends Vue {
  @(namespace(StoreModule.Global).Getter(GlobalGetters.GetMultiplier))
  multiplier!: any;
  @Prop() cartInfo!: {
    qty?: number;
    model: string;
    productline?: string;
    name?: string;
    finish?: FinishHandle;
    fabric?: Swatch[];
    options?: object;
    cost?: number;
    quickshipList?: LineItem[];
    accessoryList?: LineItem[];
    fringe?: Fringe;
    fringeFabric?: any[];
    sku: string;
    valance?: Valance;
    valanceFabric?: any[];
    bindingFabric?: any;
    undersideFabric?: any;
    finial?: string;
    finialFinish?: FinialFinishType | null;
    bottomPole?: string;
    rib?: string;
    /**
     * BugHerd #5 — the companion lines the umbrella page adds alongside the
     * umbrella. Optional, so every other caller of this modal is unaffected.
     */
    baseInfo?: {
      name?: string;
      model?: string;
      sku?: string;
      finish?: FinishHandle;
      options?: object;
      qty?: number;
      cost?: number;
    } | null;
    coverInfo?: {
      name?: string;
      model?: string;
      qty?: number;
      cost?: number;
    } | null;
    /**
     * How many cart lines this add produced, for the header. Deliberately not
     * `qty`: that is the per-item quantity and the body prints it as such.
     */
    itemCount?: number;
  };

  /** Header count. Falls back to qty for the one-line callers. */
  get addedCount(): number {
    return this.cartInfo.itemCount || this.cartInfo.qty || 0;
  }

  /**
   * What this click added, all lines together — the figure the Add to Quote
   * footer showed, which also includes the companion lines.
   */
  get combinedCost(): number {
    return (
      (this.cartInfo.cost || 0) +
      (this.cartInfo.baseInfo?.cost || 0) +
      (this.cartInfo.coverInfo?.cost || 0)
    );
  }

  get multiplierDisplay(): string {
    if (!this.multiplier || typeof this.multiplier !== "object") return "—";
    return priceLevelMultiplier(this.multiplier.discountpct).toString();
  }

  protected getFringeDisplayName = getFringeDisplayName;
  protected getValanceDisplayName = getValanceDisplayName;
  protected getFinialFinishDisplayName = getFinialFinishDisplayName;

  @Watch("finish")
  private getFinishName(stringHandle: FinishHandle): FinishDisplayName {
    return getFinishName(stringHandle);
  }
}
